import React from 'react';
import { Grid } from '@atlaskit/primitives';
import CompassRepositoryCard from '../compass-repository-card/index.tsx';
import type { Repository } from '../types.tsx';

export interface ConnectedRepositoryListProps {
	filteredRepositories: Repository[];
}

export const ConnectedRepositoryList: React.FC<ConnectedRepositoryListProps> = ({
	filteredRepositories,
}) => {
	if (!filteredRepositories.length) {
		return null;
	}

	return (
		<Grid gap="space.300" alignItems="center" templateColumns="1fr 1fr">
			{filteredRepositories.slice(0, 6).map((repo, idx) => (
				<CompassRepositoryCard
					key={repo.name}
					repositoryName={repo.name}
					cardVisualConfigurationIndex={idx}
				/>
			))}
		</Grid>
	);
};
